function formatMinutes(totalMinutes) {
  const days = Math.floor(totalMinutes / 1440); // 1440 mins in a day
  const hours = Math.floor((totalMinutes % 1440) / 60); // remaining hours
  const minutes = totalMinutes % 60; // remaining minutes

  const parts = [];
  if (days > 0) parts.push(`${days} day${days !== 1 ? "s" : ""}`);
  if (hours > 0) parts.push(`${hours} hr${hours !== 1 ? "s" : ""}`);
  if (minutes > 0 || parts.length === 0)
    parts.push(`${minutes} min${minutes !== 1 ? "s" : ""}`);

  return parts.join(" ");
}

export default formatMinutes;
